import React, { useState } from 'react';
import '../Cards/Cards.css';

const Cards = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [selectedCards2, setSelectedCards2] = useState([]);
  const [overlayImg, setOverlayImg] = useState(null); 

  const handleCardClick = (id, imgSrc) => {
    setSelectedCards((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((cardId) => cardId !== id)
        : [...prevSelected, id]
    );
    setOverlayImg(imgSrc); 
  };
  const handleCardClick2 = (id, imgSrc) => {
    setSelectedCards2((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((card2Id) => card2Id !== id)
        : [...prevSelected, id]
    );
    setOverlayImg(imgSrc); 
  };


  const handleCloseOverlay = () => {
    setOverlayImg(null); 
  };

  const cards = [
    {
      id: 1,
      imgSrc: '1.jpg',
      alt: 'Property',
      title: '2BHK+2T(1229 Sq.ft.)',
    },
    {
      id: 2,
      imgSrc: '2.jpg',
      alt: 'Property',
      title: '2BHK+2T+Study(1342 Sq.ft.)',
    },
    {
      id: 3,
      imgSrc: '3.jpg',
      alt: 'Property',
      title: '3BHK+2T(1565 Sq.ft.)',
    },
    {
      id: 4,
      imgSrc: '4.jpg',
      alt: 'Property',
      title: '3BHK+3T(1661 Sq.ft.)',
    },
    {
      id: 5,
      imgSrc: '5.jpg',
      alt: 'Property',
      title: '3BHK+2T+Store(1661 Sq.ft.)',
    },
    {
      id: 6,
      imgSrc: '6.jpg',
      alt: 'Property',
      title: '3BHK+3T+UT(1872 Sq.ft.)',
    },
  ];
  const cards2 = [
    {
      id: 1,
      imgSrc: 'phase22.jpeg',
      alt: 'Property',
      title: '3BHK+2T(1175 Sq.ft.)Mivan Constructions',
    },
   
  ];

  return (
    <>
    <div className='boddy2'>
      <section>
        <h2>Our Phase 2 Layout</h2>
        <div className="containerr2">
          {cards2.map((card2) => (
            <div
              key={card2.id}
              className={`card2 ${selectedCards2.includes(card2.id) ? 'active' : ''}`}
              onClick={() => handleCardClick2(card2.id, card2.imgSrc)}
            >
              <div className="card-inner2" style={{ '--clr': '#fff' }}>
                <div className="box2">
                  <div className="imgBox2">
                    <img src={card2.imgSrc} alt={card2.alt} />
                  </div>
                  <div className="icon2">
                    <h3>{card2.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      

      {/* Overlay for displaying the selected image */}
      {overlayImg && (
        <div className="overlay">
          <div className="overlay-content">
            <img src={overlayImg} alt="Overlay" />
            <button className="overlay-close" onClick={handleCloseOverlay}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
    <div className='boddy'>
      <section>
        <h2>Our Phase 1 Layouts</h2>
        <div className="containerr">
          {cards.map((card) => (
            <div
              key={card.id}
              className={`card ${selectedCards.includes(card.id) ? 'active' : ''}`}
              onClick={() => handleCardClick(card.id, card.imgSrc)}
            >
              <div className="card-inner" style={{ '--clr': '#fff' }}>
                <div className="box">
                  <div className="imgBox">
                    <img src={card.imgSrc} alt={card.alt} />
                  </div>
                  <div className="icon">
                    <h3>{card.title}</h3>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      

      {/* Overlay for displaying the selected image */}
      {overlayImg && (
        <div className="overlay">
          <div className="overlay-content">
            <img src={overlayImg} alt="Overlay" />
            <button className="overlay-close" onClick={handleCloseOverlay}>
              &times;
            </button>
          </div>
        </div>
      )}
    </div>
   </>
  );
};

export default Cards;
